const GCLID_KEY = "pp_gclid";

export function captureGclid() {
  const gclid = new URLSearchParams(window.location.search).get("gclid");
  if (gclid) {
    sessionStorage.setItem(GCLID_KEY, gclid);
  }
}

export function getStoredGclid() {
  return sessionStorage.getItem(GCLID_KEY) || null;
}

export function fireConversionEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
}
